"use client";

import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
export default function Affiliatehero() {
  const prefersReducedMotion = useReducedMotion();
  const [expandedSections, setExpandedSections] = useState<Set<string>>(new Set());
  const sections = [{
    label: "Header",
    sectionId: "#header"
  }, {
    label: "Affiliate Hero",
    sectionId: "#affiliate-hero"
  }, {
    label: "Program Benefits",
    sectionId: "#program-benefits"
  }, {
    label: "Commission Tiers",
    sectionId: "#commission-tiers"
  }, {
    label: "Join CTA",
    sectionId: "#join-cta"
  }, {
    label: "Footer",
    sectionId: "#footer"
  }];
  const toggleSection = (id: string) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedSections(newExpanded);
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : 0.08
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : 12
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: prefersReducedMotion ? 0.01 : 0.52,
        ease: [0.2, 0.7, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="26198" id="affiliatehero" data-nav="light" className="bg-background text-foreground py-28 md:py-40">
      <div className="mx-auto max-w-[960px] px-5 md:px-8">
        <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col items-center text-center">
          <motion.p variants={itemVariants} className="font-default text-[12px] font-medium uppercase tracking-[0.14em] leading-none text-primary">
            Secure Connectivity
          </motion.p>

          <motion.h1 variants={itemVariants} className="mt-5 font-default font-bold text-foreground" style={{
          fontSize: "clamp(2.75rem, 5.4vw + 1rem, 5.75rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.02
        }}>
            Protect your <span className="italic font-normal text-primary">digital life</span>.
          </motion.h1>

          <motion.p variants={itemVariants} className="mt-8 font-default text-foreground max-w-[620px]" style={{
          fontSize: "clamp(1.0625rem, 0.3vw + 1rem, 1.1875rem)",
          letterSpacing: "-0.003em",
          lineHeight: 1.6
        }}>
            Expert reviews and guides for choosing the best VPN solutions to keep your data private and your connection fast.
          </motion.p>

          <motion.div variants={itemVariants} className="mt-8 flex w-full max-w-[400px] flex-col gap-3">
            {sections.map((section, i) => <div key={section.sectionId} data-index={i} onClick={() => toggleSection(section.sectionId)} className="flex cursor-pointer items-center justify-between rounded-lg bg-muted p-3 transition-colors hover:bg-muted/80">
                <span className="text-[14px] font-medium">{section.label}</span>
                <ChevronDown className={`size-4 transition-transform duration-300 ${expandedSections.has(section.sectionId) ? "rotate-180" : ""}`} />
              </div>)}
          </motion.div>

          <motion.div variants={itemVariants} className="mt-12 h-px w-3/5 bg-border" aria-hidden="true" />
        </motion.div>
      </div>
    </section>;
}